import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createMuiTheme } from '@material-ui/core';
import { DatePicker, TimePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import React, { Component } from 'react';
import classes from './DateTimePicker.module.css';
import Input from 'components/UI/Input/Input';
import YearMonthPicker from 'containers/UI/DateSelection/YearMonthPicker/YearMonthPicker';
import { formatDateForDisplay, formatTimeForDisplay, formatTimeRangeForPostFormDisplay, preparePostDateForSubmission } from 'shared/utility';

const rizaTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#36a1da',
      },
    },
    MuiPickersDatePickerRoot: {
      toolbar: {
        display: 'none !important',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
      iconButton: {
        padding: '12px 8px',
      },
      dayLabel: {
        width: '44px',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '231px',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#36a1da',
        width: '44px',
        height: '44px',
      },
      daySelected: {
        '&:hover:not($disabled):not($error):not($focused)': {
          backgroundColor: '#36a1da',
        },
        backgroundColor: '#36a1da',
      },

      current: {
        color: '#36a1da',
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#36a1da',
      },
    },
    MuiPickersStaticWrapper: {
      staticWrapperRoot: {
        borderRadius: '0px',
        marginTop: '0px',
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        maxWidth: 'none',
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#36a1da',
      },
      thumb: {
        backgroundColor: '#36a1da',
        border: '14px solid #36a1da',
      },
      noPoint: {
        backgroundColor: '#36a1da',
      },
    },
    MuiPickersClockNumber: {
      clockNumberSelected: {
        backgroundColor: '#36a1da',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: '#36a1da',
      },
    },
  },
});

class DateTimePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDate: 'dateStart',
      activeTime: 'timeStart',
      showYearMonthPicker: false,
    };
  }

  componentDidMount() {
    const dateIsMonthYear = typeof this.props[this.state.activeDate] === 'string' && this.props[this.state.activeDate].includes('/00/');
    if (dateIsMonthYear) this.setState({ showYearMonthPicker: true });
    this.setState({ activeDate: 'dateStart' });
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) this.setState({ activeDate: 'dateStart' });
  }

  handleDateStartSelection = (date) => {
    this.props.handleDateSelect(date, 'dateStart');
    this.setState({ activeDate: 'dateEnd' });
  };

  handleTimeSelection = (e, fieldName) => {
    this.props.handleTimeSelect(e, fieldName);
  };

  handleDateSelection = (e, fieldName) => {
    this.props.handleDateSelect(e.toDate(), fieldName);
  };

  handleTimeFieldSelection = (fieldName) => {
    this.setState({ activeTime: fieldName });
  };

  handleDateFieldSelection = (activeDate) => {
    const showYearMonthPicker = activeDate === 'dateEnd' && this.state.showYearMonthPicker ? false : this.state.showYearMonthPicker;
    this.setState({ activeDate, showYearMonthPicker });
  };

  handleTodaySelection = () => {
    this.props.handleDateSelect(new Date(), this.state.activeDate);
    this.setState({ showYearMonthPicker: false });
  };

  // handleDatePickerLaunch() {
  //   this.setState({ showTimePicker: true });
  // }

  handleNowSelect = (dateType) => {
    this.handleTimeSelection(new Date(), dateType);
  };

  toggleTimePicker = () => {
    if (this.props.openedDrawer === 'Dates') {
      if (this.props.timeStart === null) {
        this.handleNowSelect('timeStart');
      }
      this.props.toggleRenderStatus('Times');
    } else {
      this.props.toggleRenderStatus('Dates');
    }
  };

  closeDrawer = () => {
    if (this.props.openedDrawer === 'Dates') {
      this.props.close();
    } else {
      this.toggleTimePicker();
    }
  };

  render = () => {
    const DatePickerClasses = this.props.openedDrawer === 'Times' ? [classes.DatePickerContainer, classes.Hide] : [classes.DatePickerContainer];
    const TimePickerClasses = this.props.openedDrawer === 'Times' ? [classes.TimePickerContainer, classes.Show] : [classes.TimePickerContainer];
    if (this.props.type) DatePickerClasses.push(classes[this.props.type]);
    /* Start: Date Formatting for YearMonth and Date Pickers */
    const dateIsMonthYear = typeof this.props[this.state.activeDate] === 'string' && this.props[this.state.activeDate].includes('/00/');
    let defaultYear = null;
    let defaultMonth = null;
    let selectedYear = null;
    let selectedMonth = null;

    const startDateForPicker =
      this.props.dateStart === null
        ? preparePostDateForSubmission(new Date())
        : typeof this.props.dateStart === 'string' && this.props.dateStart.includes('/00/')
        ? `${this.props.dateStart.split('/')[0]}/01/${this.props.dateStart.split('/')[2]}`
        : preparePostDateForSubmission(this.props.dateStart, false);

    const activeDate = this.props[this.state.activeDate]
      ? dateIsMonthYear
        ? `${this.props[this.state.activeDate].split('/')[0]}/01/${this.props[this.state.activeDate].split('/')[2]}`
        : this.props[this.state.activeDate].toString().toLowerCase().includes('ongoing')
        ? preparePostDateForSubmission(new Date())
        : preparePostDateForSubmission(this.props[this.state.activeDate]) !== undefined
        ? preparePostDateForSubmission(this.props[this.state.activeDate])
        : new Date().toString()
      : this.props.requireStartDateBeforeEndDate
      ? startDateForPicker
      : preparePostDateForSubmission(new Date());

    if (dateIsMonthYear) {
      selectedMonth = parseInt(activeDate.split('/')[0], 10);
      selectedYear = parseInt(activeDate.split('/')[2], 10);
    } else {
      defaultMonth = parseInt(activeDate.split('/')[0], 10);
      defaultYear = parseInt(activeDate.split('/')[2], 10);
    }

    /* End: Date Formatting for YearMonth and Date Pickers */
    let datePicker = null;

    if (this.props.visible && this.state.showYearMonthPicker) {
      datePicker = (
        <div className={classes.YearMonthPickerContainer}>
          <YearMonthPicker
            visible={this.props.visible}
            type={this.props.type}
            defaultYear={defaultYear}
            defaultMonth={defaultMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            minMonth={
              this.state.activeDate === 'dateEnd'
                ? this.props.dateStart === null
                  ? null
                  : parseInt(startDateForPicker.split('/')[0], 10) > 0
                  ? parseInt(startDateForPicker.split('/')[0], 10)
                  : 1
                : null
            }
            minYear={
              this.state.activeDate === 'dateEnd' ? (this.props.dateStart === null ? null : parseInt(startDateForPicker.split('/')[2], 10)) : null
            }
            activeDate={this.state.activeDate}
            handleDateSelection={this.props.handleDateSelect}
            close={() => this.setState({ showYearMonthPicker: false })}
          />
        </div>
      );
    } else if (this.props.visible && !this.state.showYearMonthPicker) {
      datePicker = (
        <div>
          <div className={classes.CalendarHeader}>
            <div className={classes.InnerContainer} onClick={() => this.setState({ showYearMonthPicker: true })}>
              <FontAwesomeIcon icon="chevron-left" className={classes.BackIcon} />
              <span>Month / Year</span>
            </div>
          </div>
          <DatePicker
            variant="static"
            autoOk
            label="Start Date"
            emptyLabel={this.props.dateLabel}
            clearable="false"
            format="MMM d, yyyy"
            minDate={this.state.activeDate === 'dateEnd' && this.props.dateStart ? this.props.dateStart.toString() : '0001-01-01'}
            maxDate={
              this.state.activeDate === 'dateStart' && this.props.dateEnd && this.props.dateEnd !== 'ONGOING'
                ? this.props.dateEnd.toString()
                : '3000-01-01'
            }
            value={activeDate}
            onChange={(date) => this.handleDateSelection(date, this.state.activeDate)}
            className={classes.DatePickerCalendar}
          />
        </div>
      );
    }

    return (
      <ThemeProvider theme={rizaTheme}>
        <div className={DatePickerClasses.join(' ')}>
          <p className={classes.ClearDates} onClick={() => this.props.handleDateClear(this.state.activeDate)}>
            Clear
          </p>
          <div className={classes.PickerFields}>
            <div className={[classes.Picker, classes.DatePicker].join(' ')} onClick={() => this.handleDateFieldSelection('dateStart')}>
              <Input
                elementType="input"
                className={this.state.activeDate === 'dateStart' ? classes.Active : ' '}
                label={this.props.dateStart ? 'Start Date' : '\n'}
                placeholder="Date Start"
                value={this.props.dateStart ? formatDateForDisplay(this.props.dateStart) : ''}
                readOnly
              />
            </div>
            <div className={[classes.Picker, classes.DatePicker].join(' ')} onClick={() => this.handleDateFieldSelection('dateEnd')}>
              <Input
                elementType="input"
                className={this.state.activeDate === 'dateEnd' ? classes.Active : ''}
                label={this.state.activeDate !== 'dateEnd' ? '\n' : 'End Date'}
                placeholder={this.state.activeDate !== 'dateEnd' ? 'End Date (optional)' : '\n'}
                value={this.props.ongoing === true ? 'Ongoing' : this.props.dateEnd ? formatDateForDisplay(this.props.dateEnd) : ''}
                readOnly
              />
            </div>
          </div>
          <div className={classes.OptionsPickerContainer}>
            <div className={classes.DateOptions}>
              <span className={classes.DateOption} onClick={() => this.handleTodaySelection(this.state.activeDate)}>
                Today
              </span>
              <span className={classes.TimeToggle} onClick={this.toggleTimePicker}>
                {this.props.timeStart !== null || this.props.timeEnd !== null ? (
                  formatTimeRangeForPostFormDisplay(this.props.timeStart, this.props.timeEnd, this.props.ongoing)
                ) : (
                  <FontAwesomeIcon className={classes.Clock} icon={['far', 'clock']} />
                )}
              </span>
              <span className={classes.DateOption} onClick={this.props.handleOngoingSelection}>
                {' '}
                Ongoing{' '}
              </span>
            </div>
            <div className={classes.CalendarContainer}>{datePicker}</div>
          </div>
        </div>
        <div className={TimePickerClasses.join(' ')}>
          <p className={classes.ClearDates} onClick={() => this.props.handleTimeClear(this.state.activeTime)}>
            Clear
          </p>
          <div className={classes.PickerFields}>
            <div className={[classes.Picker, classes.DatePicker].join(' ')} onClick={() => this.handleTimeFieldSelection('timeStart')}>
              <Input
                elementType="input"
                className={this.state.activeTime === 'timeStart' ? classes.Active : ' '}
                label={this.props.timeStart ? 'Start Time' : ''}
                placeholder="Start Time (optional)"
                value={this.props.timeStart !== null ? formatTimeForDisplay(this.props.timeStart) : ''}
                readOnly
              />
            </div>
            <div className={[classes.Picker, classes.DatePicker].join(' ')} onClick={() => this.handleTimeFieldSelection('timeEnd')}>
              <Input
                elementType="input"
                className={this.state.activeTime === 'timeEnd' ? classes.Active : ''}
                label={this.state.activeTime !== 'timeEnd' ? '\n' : 'End Time'}
                placeholder={this.state.activeTime !== 'timeEnd' ? 'End Time (optional)' : '\n'}
                value={this.props.timeEnd ? formatTimeForDisplay(this.props.timeEnd) : ''}
                readOnly
              />
            </div>
          </div>
          <div className={classes.OptionsPickerContainer}>
            <div className={classes.TimeOptions}>
              <span onClick={() => this.handleNowSelect(this.state.activeTime)}>Now</span>
            </div>
            <TimePicker
              variant="static"
              openTo="hours"
              initialFocusedDate={this.props.timeStart ? this.props.timeStart.toString() : null}
              autoOk
              // className={classes.TimePicker}
              clearable="false"
              value={this.state.activeTime === 'timeStart' ? this.props.timeStart : this.props.timeEnd}
              onChange={(e) => this.handleTimeSelection(e, this.state.activeTime)}
            />
          </div>
        </div>
      </ThemeProvider>
    );
  };
}

export default DateTimePicker;
